// import { useEffect, useState } from "react";
// import "../css/NewsTicker.css";

// const statsData = [
//   { id: 1, icon: "fas fa-users", number: 500, label: "Happy Customers" },
//   { id: 2, icon: "fas fa-university", number: 5, label: "Banking Outlets" },
//   { id: 3, icon: "fas fa-credit-card", number: 10, label: "ATMs" },
//   { id: 4, icon: "fas fa-wallet", number: 100, label: "Cash Recyclers" },
// ];

// const linksData = [
//   { id: 1, icon: "fas fa-calculator", label: "Banking Tools" },
//   { id: 2, icon: "fas fa-file-invoice-dollar", label: "Rates & Charges" },
//   { id: 3, icon: "fas fa-headset", label: "Need Assistance" },
//   { id: 4, icon: "fas fa-link", label: "Quick Links" },
// ];

// const CountUp = ({ target }) => {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     let start = 0;
//     const duration = 2000; // 2 seconds
//     const increment = target / (duration / 16);

//     const timer = setInterval(() => {
//       start += increment;
//       if (start >= target) {
//         setCount(target);
//         clearInterval(timer);
//       } else {
//         setCount(Math.floor(start));
//       }
//     }, 16);

//     return () => clearInterval(timer);
//   }, [target]);

//   return <>{count.toLocaleString()}</>;
// };

// const StatisticsPanel = () => {
//   return (
//     <div className="stats-panel-container">
//       {/* Top Stats Row */}
//       <div className="stats-row">
//         {statsData.map((stat) => (
//           <div key={stat.id} className="stat-item">
//             <div className="stat-icon">
//               <i className={stat.icon}></i>
//             </div>
//             <div className="stat-number">
//               <CountUp target={stat.number} />
//             </div>
//             <div className="stat-label">{stat.label}</div>
//           </div>
//         ))}
//       </div>

//       {/* Bottom Links Panel */}
//       <div className="links-panel">
//         {linksData.map((link, idx) => (
//           <div
//             key={link.id}
//             className={`link-item ${idx === 0 ? "first" : ""} ${
//               idx === linksData.length - 1 ? "last" : ""
//             }`}
//           >
//             <div className="link-icon">
//               <i className={link.icon}></i>
//             </div>
//             <div className="link-label">{link.label}</div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default StatisticsPanel;



import { useEffect, useRef, useState } from "react";
import "../css/NewsTicker.css";

const CountUp = ({ target }) => {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);
  const countRef = useRef(0);

  // Intersection Observer to start animation on scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    let startTimestamp = null;
    const duration = 2000;

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const currentCount = Math.floor(progress * target);

      if (countRef.current !== currentCount) {
        setCount(currentCount);
        countRef.current = currentCount;
      }

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        setCount(target);
      }
    };

    window.requestAnimationFrame(step);
  }, [target, isVisible]);

  return <span ref={containerRef}>{count.toLocaleString()}</span>;
};

// 🔹 Updated Stats Data for Loan/Lending Platform
const statsData = [
  { id: 1, icon: "fas fa-user-friends", number: 500, label: "Satisfied Customers", suffix: "+" },
  { id: 2, icon: "fas fa-building-columns", number: 5, label: "Branches", suffix: "+" },
  { id: 3, icon: "fas fa-hand-holding-dollar", number: 50, label: "Lac.+ Loans Disbursed", suffix: "" },
  { id: 4, icon: "fas fa-check-double", number: 99, label: "Approval Rate", suffix: "%" },
];

// 🔹 Updated Quick Links Data for Loan/Lending Tools
const linksData = [
  { id: 1, icon: "fas fa-calculator", label: "EMI Calculator" },
  { id: 2, icon: "fas fa-percent", label: "Interest Rates" },
  { id: 3, icon: "fas fa-headset", label: "Loan Assistance" },
  { id: 4, icon: "fas fa-file-contract", label: "Loan Status" },
];

const StatisticsPanel = () => {
  return (
    <div className="landing-stats-panel-wrapper">
      <div className="landing-stats-container">
        <div className="landing-stats-grid">
          {statsData.map((stat) => (
            <div key={stat.id} className="landing-stat-card">
              <div className="landing-stat-icon-box">
                <i className={stat.icon}></i>
              </div>
              <div className="landing-stat-content">
                <h3 className="landing-stat-number">
                  <CountUp target={stat.number} />{stat.suffix}
                </h3>
                <p className="landing-stat-label">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="landing-links-panel-container">
        <div className="landing-links-panel">
          {linksData.map((link) => (
            <div key={link.id} className="landing-link-item">
              <div className="landing-link-icon">
                <i className={link.icon}></i>
              </div>
              <span className="landing-link-label">{link.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatisticsPanel;